import React, { useEffect } from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
import { useIntl } from '../../util/reactIntl';
import { siteStaticPages } from '../../util/types';
const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  const { params, pageAssetsData, inProgress, error, history } = props;
  const pageId = params.pageId || props.pageId;
  const intl = useIntl();

  useEffect(() => {
    try {
      const locale = (intl?.locale || '').toLowerCase();
      const isArabic = locale.startsWith('ar');
  
      if (!history || !pageId) return;
     // Special case: Arabic landing CMS page should not be accessible in English
      if (!isArabic && pageId === 'ar-home') {
        history.replace('/');
        return;
      }

      const pages = siteStaticPages;
  
      // find current page
      const currentPage = pages.find(p => p?.pageId === pageId);
      if (!currentPage) {
        history.replace('/notfound');
        return;
      }
  
      const baseId = pageId.replace(/^ar-/, "");
  
      const enPage = pages.find(p => p?.language === "en" && p?.pageId === baseId);
      const arPage = pages.find(p => p?.language === "ar" && p?.pageId === `ar-${baseId}`);
  
      // CASE 1: Both pages exist → normal locale switching
      if (enPage && arPage) {
        if (isArabic && pageId === enPage.pageId) {
          history.replace(`/p/${arPage.pageId}`);
        } else if (!isArabic && pageId === arPage.pageId) {
          history.replace(`/p/${enPage.pageId}`);
        }
        return;
      }
  
      // CASE 2: Only EN exists → user switched to AR → NOT FOUND
      if (enPage && !arPage) {
        if (isArabic) {
          history.replace('/notfound');
        }
        return;
      }
  
      // CASE 3: Only AR exists → user switched to EN → NOT FOUND
      if (!enPage && arPage) {
        if (!isArabic) {
          history.replace('/notfound');
        }
        return;
      }
  
      // CASE 4: Neither exists → NOT FOUND
      history.replace('/notfound');
  
    } catch (err) {
      console.error("Locale auto-switch error:", err);
      history.replace('/notfound');
    }
  }, [history, intl, pageId]);
  

  if (!inProgress && error?.status === 404) {
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[pageId]?.data}
      inProgress={inProgress}
      schemaType="Article"
    />
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(
  withRouter,
  connect(mapStateToProps)
)(CMSPageComponent);

export default CMSPage;
